import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import { Img } from "arv-reactcomponents";
import { NOT_FOUND, URL_CONFIG, pageType } from "npmlinks-constants";

import { setPageType, queryParamsToObject } from "../../utils";
import Analytics from "../../analytics";

@inject("CommonStore")
@observer
class NotFound extends Component {
  static getImage(isDesktop) {
    return (isDesktop && NOT_FOUND.IMAGE.DESKTOP) || NOT_FOUND.IMAGE.MOBILE;
  }
  constructor() {
    super();
    this.redirect = true;
    this.redirectToHome = this.redirectToHome.bind(this);
  }
  componentDidMount() {
    setPageType(pageType.notFound);
    const query = queryParamsToObject(window.location.search);
    Analytics.trackEvent({
      category: window.pageType,
      action: (query && query.from) || "none",
    });
    this.redirectToHome();
  }
  redirectToHome() {
    const isItHome = window.location.pathname === "/";
    const is404 = window.location.pathname === URL_CONFIG.NOT_FOUND;
    if (!isItHome && !is404 && this.redirect) {
      window.location.href = `${window.location.origin}${
        URL_CONFIG.NOT_FOUND
      }?from=${window.location.pathname}`;
    }
  }
  render() {
    const { isDesktop } = this.props.CommonStore;

    return (
      <div className="nw-notfound-container">
        {NotFound.getImage(isDesktop) && (
          <Img className="nw-notfound-image" src={NotFound.getImage(isDesktop)} />
        )}
        <div className="nw-notfound-textcontainer">
          <h1 className="nw-notfound-text">{NOT_FOUND.TITLE}</h1>
          <h3 className="nw-notfound-message">{NOT_FOUND.MESSAGE}</h3>
        </div>
      </div>
    );
  }
}

NotFound.wrappedComponent.propTypes = {
  CommonStore: PropTypes.shape({
    isDesktop: PropTypes.bool.isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("CommonStore")(observer(component));

export const ProjectComponent = {
  getFinalComponent,
  wrapper: NotFound.wrappedComponent,
  component: NotFound,
};

export default ProjectComponent.component;
